import ForgotPasswordPage from '@/pages/auth/forgot-password/page'
import AuthRegisterPage from '@/pages/auth/register/page'
import ResetPasswordPage from '@/pages/auth/reset-password/page'
import SetupPasswordPage from '@/pages/auth/setup-password/page'
import { Route, Routes } from 'react-router-dom'
import { PublicLayout } from '../layouts/public/public-layout'
import Login from '../pages/auth/login/page'

const PublicRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<PublicLayout />}>
                <Route path="/" element={<Login />} index />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<AuthRegisterPage />} />
                <Route
                    path="/auth/forgot-password"
                    element={<ForgotPasswordPage />}
                />
                <Route
                    path="/auth/reset-password"
                    element={<ResetPasswordPage />}
                />
                <Route
                    path="/auth/setup-password"
                    element={<SetupPasswordPage />}
                />
            </Route>
        </Routes>
    )
}

export default PublicRoutes
